import { combineReducers } from 'redux';
import stallion from './stallion';
import switchers from './switchers';
import filter from './filter';


const rootReducer = combineReducers({
    stallion,
    switchers,
    filter
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/client/reducers/index.js